"use strict";
/**
 * @file Created on Thu Dec 12 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var DummyWindowSimulationParams_1 = require("./DummyWindowSimulationParams");

var Window_1 = require("./Window");

var WindowItem_1 = require("./WindowItem");
/**
 * @author Tomáš Leity
 */


var DummyWindowSimulationSession =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(DummyWindowSimulationSession, _DomainObject_1$Domai);

  /**
   * @param id
   * @param params
   * @param window
   * @param windowItem
   */
  function DummyWindowSimulationSession(id, params, window, windowItem) {
    var _this;

    _classCallCheck(this, DummyWindowSimulationSession);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DummyWindowSimulationSession).call(this));
    _this.id = id;
    _this.params = params;
    _this.window = window;
    _this.windowItem = windowItem;
    return _this;
  }
  /**
   * Converter from data-dictionary representation
   */


  _createClass(DummyWindowSimulationSession, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new DummyWindowSimulationSession(mat.id, mat.params, mat.window, mat.windowItem);
    }
  }]);

  return DummyWindowSimulationSession;
}(DomainObject_1.DomainObject);

exports.DummyWindowSimulationSession = DummyWindowSimulationSession;
DummyWindowSimulationSession.DOCUMENT_TYPE = DummyWindowSimulationSession.name;

DummyWindowSimulationSession.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(DummyWindowSimulationSession.name);
  return {
    id: builder.id('id'),
    params: builder.obj('params', DummyWindowSimulationParams_1.DummyWindowSimulationParams.schema, function (mat) {
      return DummyWindowSimulationParams_1.DummyWindowSimulationParams.fromDataDict(mat);
    }),
    window: builder.obj('window', Window_1.Window.schema, function (mat) {
      return Window_1.Window.fromDataDict(mat);
    }),
    windowItem: builder.obj('windowItem', WindowItem_1.WindowItem.schema, function (mat) {
      return WindowItem_1.WindowItem.fromDataDict(mat);
    })
  };
}();